module.exports = __webpack_public_path__ + "static/media/CI.62147a74.svg";